export interface SensitiveData {
  location?: {
    zipCode?: string;
  };
}

export interface SensitiveState {
  sensitiveData: SensitiveData;
  setLocationData: (location: Partial<SensitiveData['location']>) => void;
  clearSensitiveData: (defaultValues?: SensitiveData) => void;
}

export enum StoreKeys {
  SENSITIVE_DATA = 'sensitiveData',
  SET_LOCATION_DATA = 'setLocationData',
  CLEAR_SENSITIVE_DATA = 'clearSensitiveData',
}

export const initialState = {
  [StoreKeys.SENSITIVE_DATA]: {},
};
